import { BsCircleFill } from 'react-icons/bs';
import { Column } from 'utils/models';
import { WorklistData, WorklistStatus } from 'models/worklist';
import { PriorityIcon } from 'components/PriorityIcon';
import { t } from 'i18next';
import { formatBirthday, formatDate } from 'utils/dates';
import { GroupBadge } from 'components/GroupBadge';
import { DataFieldNames } from 'pages/Main/Worklist/WorklistTable.config';
import { useNavigate } from 'react-router-dom';
import { PatientDetailsTabs } from 'pages/Main/Patients/Patients.helpers';
import { useActions } from '../Actions/WorkListActions';
import { TableColumnActions } from '../TableBody/TableColumnActions';

type ColumnType = Column<WorklistData>;

export const WorkListColumns = (): ColumnType[] => {
  const navigate = useNavigate();

  const actions = useActions();

  const columns: ColumnType[] = [
    {
      header: '',
      width: 2.5,
      renderItem: (item) => item.status === WorklistStatus.Unread && <BsCircleFill size={8} />,
    },
    {
      header: t('title_label'),
      width: 20,
      renderItem: (item) => item.content.title,
      sortFieldName: DataFieldNames.title,
    },
    {
      header: t('priority_label'),
      width: 10,
      renderItem: (item) => <PriorityIcon priority={item.content.priority} />,
      sortFieldName: DataFieldNames.priority,
    },
    {
      header: t('timestamp_label'),
      width: 12,
      renderItem: (item) =>
        item.notificationCreationTimestamp &&
        formatDate({ timestamp: item.notificationCreationTimestamp, formatWithTime: true, timeWithSeconds: false }),
      sortFieldName: DataFieldNames.timestamp,
    },
    {
      header: t('patient_info_label'),
      width: 15,
      renderItem: (item) => <b>{`${item.attachments.patientLastName} ${item.attachments.patientFirstName}`}</b>,
      onClick: (item: WorklistData) =>
        navigate(`/patients/${item?.attachments?.patientId}/details/${PatientDetailsTabs.Overview}`),
      sortFieldName: DataFieldNames.patient,
    },
    {
      header: t('birthday_label'),
      width: 12,
      renderItem: (item) => formatBirthday(item.attachments.patientBirthday, true),
      sortFieldName: DataFieldNames.birthday,
    },
    {
      header: t('group_label'),
      width: 16,
      renderItem: (item) => (
        <GroupBadge key={item.recipients.groupId} label={item.recipients.groupName} groupId={item.recipients.groupId} />
      ),
      sortFieldName: DataFieldNames.groupName,
    },
    {
      header: t('table_actions'),
      width: 10,
      renderItem: (item) => <TableColumnActions<WorklistData> actions={actions} item={item} />,
    },
  ];
  return columns;
};
